var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShowAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.5,
    height: 17.234,
    viewBox: "0 0 25.5 17.234",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_4",
    "data-name": "Subtraction 4",
    d: "M-4836.25-1484.766a13.665,13.665,0,0,1-7.788-2.412,13.7,13.7,0,0,1-4.962-6.2,13.7,13.7,0,0,1,4.962-6.2,13.663,13.663,0,0,1,7.788-2.413,13.662,13.662,0,0,1,7.787,2.413,13.707,13.707,0,0,1,4.962,6.2,13.7,13.7,0,0,1-4.962,6.2A13.664,13.664,0,0,1-4836.25-1484.766Zm0-14.363a5.777,5.777,0,0,0-5.794,5.746,5.777,5.777,0,0,0,5.794,5.746,5.777,5.777,0,0,0,5.793-5.746A5.777,5.777,0,0,0-4836.25-1499.129Zm0,9.193a3.467,3.467,0,0,1-3.479-3.447,3.4,3.4,0,0,1,.555-1.861,2.025,2.025,0,0,0,1.911,1.36,2.029,2.029,0,0,0,2.024-2.03,2.009,2.009,0,0,0-.169-.813,3.453,3.453,0,0,1,2.635,3.344A3.466,3.466,0,0,1-4836.25-1489.936Z",
    transform: "translate(4849 1502)",
    fill: "#bf772f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowAll);
export default __webpack_public_path__ + "static/media/show-all.156660403cca1a2d219fd47952c6e5f9.svg";
export { ForwardRef as ReactComponent };